// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import styles from './styles';


class Total extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    value: PropTypes.string,
    text: PropTypes.string,
  };

  static defaultProps = {
    classes: {},
    value: null,
    text: null,
  };

  render() {
    const {
      classes,
      value,
      text,
    } = this.props;

    return (
      <div className={classes.container}>
        <p className={classes.text}>{value}</p>
        <p className={classes.descText}>{text}</p>
      </div>
    );
  }
}

export default (withStyles(styles)(Total));
